export const payrollpartnersList = 'payrollpartnersList';
export const newHireContactList = 'newHireContactList';
export const onboardPackagesList = 'onboardPackagesList';